import HighLevelIcon from '../../assets/Svg/HighLevelicon';
import MediumLevelIcon from '../../assets/Svg/MediumLevelIcon';
import LowLevelIcon from '../../assets/Svg/LowLevelIcon';
import CompanyLegalNameSearch from '../CompanyLegalNameSearch/CompanyLegalNameSearch';
import { EstimateButtonIcon } from '../../assets/Svg/EstimateButtonIcon';
import LoadingSpinner from '../_custom/LoadingSpinner/LoadingSpinner';
import FetchFillIcon from '../../assets/Svg/FetchFilIcon';
import { caretRightPurple, GREEN_BG_WHITE_TICK_CIRCLE, plusPurpleCircle } from '../../assets/hostedassets';
import infoIconYellow from '../../assets/info-yellow.svg';
// Field keys + designation labels consumed both here (MANDATE_APPLICANT_FIELD_ORDER /
// MANDATE_APPLICANT_TYPE_OPTIONS below) and by the pure-logic Sections/*Types.ts validators; they
// live in a component-free leaf so those validators can import them without a circular-import TDZ.
import { MANDATE_APPLICANT_DESIGNATION_LABELS, MANDATE_APPLICANT_FIELD_KEYS, REQUIRED_FIELD_ERROR } from './MandateFormConstants';

export const EXCLUDED_LABEL_TYPES = ['recur-investor-toggle', 'investor-toggle'];
export const AICA_CREATE_DEAL_DETAILS = 'AICA_CREATE_DEAL_DETAILS';
/** Mnemosyne flow for deal-drawer / Share Deal attachments. Not in Godzilla ViewConfig. */
export const MNEMOSYNE_DEAL_ATTACHMENT_FLOW_ID = 16;
export const AICA_INVESTMENT_PREFERENCE = 'AICA_INVESTMENT_PREFERENCE';
export const AICA_COMPANY_PROFILE = 'AICA_COMPANY_PROFILE';
export const DEBT_PRODUCT_FILTERS = 'Debt Products Filters';
export const EDIT_PROFILE = 'Edit Profile';
export const AICA_YOUR_PROFILE = 'AICA_YOUR_PROFILE';
export const AICA_PARTNER_PROFILE = 'AICA_PARTNER_PROFILE';
export const PROFILE_BUTTON = 'ProfileButton';
export const PROFILE_LABEL = 'Your Profile';
export const ORG_USERS_TABLE = 'OrgUsersTable';

// True for both profile-editing entry points into the deal drawer: the logged-in user's own
// "Your Profile" (PROFILE_BUTTON) and an admin editing another org's profile from OrgUsersTable.
export const isProfileDrawerSource = (source: string | undefined): boolean => source === PROFILE_BUTTON || source === ORG_USERS_TABLE;
export const PROFILE_CUSTOM_FIELD_KEYS = [
    'priority',
    'relationshipStrength',
    'productPreference',
    'focus',
    'avgChequeSize',
    'coi',
    'sectoralPreference',
    'policyDocStatus',
] as const;
export const CREATE_INVESTMENT_PREFERENCE = 'CreateInvestmentPreference';
export const FY_END_DATE = '31 Mar';
export const AUDITED_COLUMN_HEADING = 'Audited';

export const PROFILE = 'PROFILE';

// Dual Data Storage Constants
export const DATA_SOURCE_TYPE = {
    ACTUAL_DATA: 'actualData',
    DISCUSSION: 'discussion',
    BOTH: 'both',
} as const;

export const UPLOAD_FILES_PREFIXES = {
    ONEPAGER_PREFIX: 'ONEPAGER_',
    ATTACHMENT_PREFIX: 'ATTACHMENT_',
    INVESTMENTREPORT__PREFIX: 'INVESTMENTREPORT_',
};

export const FILE_SHARE_STATUS = {
    SEND_TO_INVESTOR: 'SEND_TO_INVESTOR',
    SKIP_NOTIFICATION: 'SKIP_NOTIFICATION',
};

export const AICA_GET_COMPANY_SECTOR_LIST = 'AICA_GET_COMPANY_SECTOR_LIST';

export enum CONFIG_STEP {
    PREFERRED_TERMS = 'PREFERRED_TERMS',
    BORROWER_PROFILE = 'BORROWER_PROFILE',
    DEAL_TERMS = 'DEAL_TERMS',
    SELECT_INVESTORS = 'SELECT_INVESTORS',
    BORROWER_FINANCIALS = 'BORROWER_FINANCIALS',
    PRIMARY_APPLICANT = 'PRIMARY_APPLICANT',

    preferredTerms = 'preferredTerms',
    borrowerProfile = 'borrowerProfile',
    dealTerms = 'dealTerms',
    primaryApplicant = 'primaryApplicant',
}

export enum CONFIG_TYPE {
    TEXTAREA = 'textarea',
    SEARCH_DROPDOWN = 'search-dropdown',
    DROPDOWN = 'dropdown',
    NUMBER = 'number',
    MULTIPLE_SELECT = 'multiple-select',
    MULTIPLE_SELECT_WITH_SEARCH = 'multiple-select-with-search',
    MULTIPLE_SELECT_WITH_INPUT = 'multiple-select-with-input',
    MULTIPLE_SELECT_WITH_INPUT_AND_SEARCH = 'multiple-select-with-input-and-search',
    RANGE = 'range',
    DROPDOWN_WITH_API = 'dropdown-with-api',
    MULTIPLE_SELECT_API = 'multiple-select-api',
    MULTIPLE_SELECT_API_FILTER = 'multiple-select-api-filter',
    MULTIPLE_SELECT_FILTER = 'multiple-select-filter',
    MULTIPLE_SELECT_API_FILTER_INLINE = 'multiple-select-api-filter-inline',
    RECUR_INVESTOR_TOGGLE = 'recur-investor-toggle',
    INVESTOR_TOGGLE = 'investor-toggle',
    UPLOAD = 'upload',
    BUTTON = 'button',
    RANGE_FILTER = 'range-filter',
    INPUT_WITH_MODAL_BUTTON = 'input-with-modal-button',
    MULTI_MULTIPLE_SELECT = 'multi-multiple-select',
    MULTI_MULTIPLE_SELECT_WITH_SEARCH = 'multi-multiple-select-with-search',
    DROPDOWN_WITH_CUSTOM_COMPONENT = 'dropdown_with_custom_component',
    DATE = 'date',
    READ_ONLY_COMPARE_NUMBER = 'read-only-compare-number',
    READ_ONLY_COMPARE_INPUT_WITH_MODAL_BUTTON = 'read-only-compare-input-with-modal-button',
    READ_ONLY_COMPARE_INPUT_WITH_DATE = 'read-only-compare-input-with-date',
    READ_ONLY_COMPARE_DROPDOWN = 'read-only-compare-dropdown',
    MULTI_SELECT_WITH_DISABLED_OPTIONS = 'multi-select-with-disabled-options',
    SINGLE_SELECT_DROPDOWN_WITH_SEARCH = 'single-select-dropdown-with-search',
    READ_ONLY_TOGGLE = 'read-only-toggle',
    EDITOR = 'editor',
}

export const CUSTOM_COMPONENT_MAP: Record<string, React.FC<any>> = {
    COMPANY_LEGAL_NAME_SEARCH: CompanyLegalNameSearch,
};

export const DEFAULT_OWNER_TYPE = 'dealOwner';
export const DEAL_CREATOR_TYPE = 'dealCreator';

export const IMPORTANCE_LEVELS = [
    {
        id: 'Critical',
        label: 'Critical',
        icon: 'https://fl-fe-assets.s3.ap-south-1.amazonaws.com/svg/CriticalIcon.svg',
    },
    {
        id: 'High',
        label: 'High',
        icon: <HighLevelIcon colour="var(--primary-text-colour)" height="12" width="12" style={{ marginTop: '4px' }} />,
    },
    {
        id: 'Medium',
        label: 'Medium',
        icon: <MediumLevelIcon colour="var(--primary-text-colour)" height="12" width="12" style={{ marginTop: '4px' }} />,
    },
    {
        id: 'Low',
        label: 'Low',
        icon: <LowLevelIcon colour="var(--primary-text-colour)" height="12" width="12" style={{ marginTop: '5px' }} />,
    },
    {
        id: 'Not Needed',
        label: 'Not Needed',
        icon: 'https://fl-fe-assets.s3.ap-south-1.amazonaws.com/svg/notInterestedIcon.svg',
    },
];

export const USER_TYPE = {
    ADMIN: 'ADMIN',
    ADMIN_TEAM: 'ADMIN_TEAM',
    COMPANY: 'COMPANY',
    INVESTOR: 'INVESTOR',
    LENDER: 'LENDER',
    LENDER_TEAM: 'LENDER_TEAM',
    PARTNER: 'PARTNER',
    ASSESSEE: 'ASSESSEE',
};

export const STEPPER_STATUS = {
    UNLOCKED: 'UNLOCKED',
    LOCKED: 'LOCKED',
};

export const PEC_STATUS = {
    PEC: 'PEC',
    PEC_DUPLICATED: 'PEC Duplicated',
    PEC_CREATED: 'PEC Created',
};

export const PEC_IMPORTANCE_CONSTANTS = {
    CRITICAL: 'Critical',
    HIGH: 'High',
    MEDIUM: 'Medium',
    LOW: 'Low',
    NOT_NEEDED: 'Not Needed',
};

export const DEAL_DRAWER_ICON_MAP = {
    VERIFY_WEBSITE: {
        LOADING: <LoadingSpinner color={'var(--primary-text-colour)'} />,
        INVALID: <FetchFillIcon colour={'var(--primary-text-colour)'} height="15" width="15" className="customFetch" />,
        VALID: <img src={GREEN_BG_WHITE_TICK_CIRCLE} alt="" className="customFetch" />,
    },
    DETAILS_IMG: plusPurpleCircle,
    CALCULATE_IMG: caretRightPurple,
    ESTIMATE_IMG: <EstimateButtonIcon color="var(--primary-text-colour)" />,
    INFO_ICON_YELLOW: infoIconYellow,
};

export const RANGE_REQUIREMENT = {
    MIN: 'min',
    MAX: 'max',
    BOTH: 'both',
};

export const ERROR_MESSAGES = {
    REQUIRED: REQUIRED_FIELD_ERROR,
    INVALID_RANGE: 'Invalid range',
};

export const DYNAMIC_INPUT_TYPES = [CONFIG_TYPE.MULTIPLE_SELECT_WITH_INPUT_AND_SEARCH, CONFIG_TYPE.MULTIPLE_SELECT_WITH_INPUT];

export const METADATA_KEYS_FOR_BORROWER_FINANCIALS = ['dataAsOfDate', 'lastUpdatedAt'];

export const PEC_REMOVE_ALL_CONFIRM = {
    heading: 'Remove all preferences?',
    message: 'All preferences on this step will be removed, and their saved values will be cleared when you save.',
    confirmLabel: 'Yes, Remove All',
    cancelLabel: 'Cancel',
};

export const PEC_SELECTED_FIELDS_KEYS: Record<string, string> = {
    preferredTerms: 'profile.selectedFieldsPreferredTerms',
    borrowerProfile: 'profile.selectedFieldsBorrowerProfile',
    borrowerFinancials: 'profile.selectedFieldsBorrowerFinancials',
};

export const PEC_PICKER_LABELS = {
    pickerLabel: 'Investment Preferences:',
    pickerPlaceholder: 'Select Investment Preferences',
    add: 'Add',
    addPreferences: 'Add Preferences',
    clearAll: 'Clear All',
    removeAll: 'Remove All',
    cardTitle: 'Configure Investment',
    emptyText: 'Add your investment preferences to help find the right deals',
};

// Deals -> Mandate view kebab item ("Application Form") that opens the drawer to capture a
// primary applicant + co-applicants against a specific mandate/deal.
export const MANDATE_APPLICATION_FORM_LABEL = 'Application Form';
export const MANDATE_APPLICATION_FORM = 'MandateApplicationForm';

// Config-driven fields rendered via FormSection (real godzilla PRIMARY_APPLICANT entries), in
// display order. Phone/Email/the "same as current" toggle have no config entry and are
// hand-rendered by ApplicantFieldsBlock; permanentAddressOwnership has no config entry either and
// is cloned client-side from currentAddressOwnership.
export const MANDATE_APPLICANT_FIELD_ORDER = [
    MANDATE_APPLICANT_FIELD_KEYS.NAME,
    MANDATE_APPLICANT_FIELD_KEYS.PAN,
    MANDATE_APPLICANT_FIELD_KEYS.MOTHER_NAME,
    MANDATE_APPLICANT_FIELD_KEYS.DOB,
    MANDATE_APPLICANT_FIELD_KEYS.CURRENT_ADDRESS,
    MANDATE_APPLICANT_FIELD_KEYS.CURRENT_ADDRESS_OWNERSHIP,
];

export const MANDATE_APPLICANT_PHONE_COUNTRY_CODE_PREFIX = '+91';

// Shared by both pincode inputs' inline error - the copy carries no section-specific wording.
export const INVALID_PINCODE_MESSAGE = 'Enter a valid 6-digit pincode';

export const MANDATE_APPLICANT_LABELS = {
    sectionHeading: '2. Applicant Details',
    phoneLabel: 'Phone Number',
    phonePlaceholder: 'Phone Number',
    emailLabel: 'Email',
    emailPlaceholder: 'Email',
    currentAddressPincodeLabel: 'Current Address Pincode',
    currentAddressPincodePlaceholder: 'Enter Pincode',
    invalidPhoneMessage: 'Enter a valid 10-digit phone number',
    invalidEmailMessage: 'Enter a valid email address',
    invalidPincodeMessage: INVALID_PINCODE_MESSAGE,
    permanentSameAsCurrent: 'Permanent address same as current',
    permanentAddressOwnershipLabel: 'Permanent Address Ownership',
    yes: 'Yes',
    no: 'No',
    applicantTypeLabel: 'Applicant Type',
    applicantTypePlaceholder: 'Select Applicant Type',
    newApplicantHeader: 'New Applicant',
    incompleteApplicantMarker: 'Incomplete',
};

// "Select Applicants" multi-select + Add (Figma) - pinned at the top of Applicant Details.
// Picking an existing director or clicking Add spawns a Primary/Co-Applicant card below.
export const MANDATE_APPLICANT_PICKER_LABELS = {
    label: 'Select Applicants',
    placeholder: 'Select Applicants',
    add: 'Add',
};

export const MANDATE_APPLICANT_TYPE_OPTIONS = [
    { id: MANDATE_APPLICANT_DESIGNATION_LABELS.PRIMARY, label: MANDATE_APPLICANT_DESIGNATION_LABELS.PRIMARY },
    { id: MANDATE_APPLICANT_DESIGNATION_LABELS.CO_APPLICANT_LABEL, label: MANDATE_APPLICANT_DESIGNATION_LABELS.CO_APPLICANT_LABEL },
];

export const MANDATE_APPLICANT_REMOVE_LABEL = 'Remove';

export const MANDATE_APPLICANT_SAVE_ERROR_PREFIX = 'Failed to save applicant details';

// Business Details section (Application Form drawer, Applicant Details step). Unlike the
// Applicant/Co-applicant fields above (which stay in the real godzilla PRIMARY_APPLICANT config),
// Business Details is a mandate-level object - every value collects into a single `businessDetails`
// object saved to Deal.customFields.businessDetails, so its field labels/options are plain UI
// constants rather than looked up from another step's companyMetrics config.
export const BUSINESS_DETAILS_KEY = 'businessDetails';

export const BUSINESS_ADDRESS_OWNERSHIP_OPTIONS = [
    { id: 'Owned', label: 'Owned' },
    { id: 'Rented', label: 'Rented' },
];

export const GST_STATUS_ACTIVE = 'Active';

export const BUSINESS_DETAILS_LABELS = {
    heading: '1. Business Details',
    gstLabel: 'GST To Fill Address',
    gstPlaceholder: 'Select GSTIN To Fill Address',
    // Sentinel row appended to the GST dropdown's optionsList - picking it clears any selected
    // GST and leaves businessAddress open for manual entry.
    enterAddressManuallyOptionId: 'ENTER_ADDRESS_MANUALLY',
    enterAddressManuallyLabel: 'Enter address manually',
    businessAddressLabel: 'Business Address',
    businessAddressPlaceholder: 'Enter Business Address',
    businessAddressOwnershipLabel: 'Business Address Ownership',
    businessAddressOwnershipPlaceholder: 'Select Ownership',
    businessAddressPincodeLabel: 'Business Address Pincode',
    businessAddressPincodePlaceholder: 'Enter Pincode',
    invalidPincodeMessage: INVALID_PINCODE_MESSAGE,
    loanPurposeLabel: 'Loan Purpose',
    loanPurposePlaceholder: 'Select Loan Purpose',
    othersOptionId: 'Others',
    othersInputLabel: 'Please specify',
    othersInputPlaceholder: 'Enter loan purpose',
};

export const BUSINESS_LOAN_PURPOSE = {
    WORKING_CAPITAL: 'Working Capital',
    BUSINESS_EXPANSION: 'Business Expansion',
};

export const BUSINESS_LOAN_PURPOSE_OPTIONS = [
    { id: BUSINESS_LOAN_PURPOSE.WORKING_CAPITAL, label: BUSINESS_LOAN_PURPOSE.WORKING_CAPITAL },
    { id: BUSINESS_LOAN_PURPOSE.BUSINESS_EXPANSION, label: BUSINESS_LOAN_PURPOSE.BUSINESS_EXPANSION },
    { id: BUSINESS_DETAILS_LABELS.othersOptionId, label: BUSINESS_DETAILS_LABELS.othersOptionId },
];

// The field keys, pincode length, designations and applicant-error copy that the pure-logic
// Sections/*Types.ts validators consume live in a component-free leaf module (they cannot import
// this file without a circular-import TDZ). Re-exported so this module's importers see no change.
export * from './MandateFormConstants';
